/* ============================================================================
   MILAROS · shared storefront interactions (Modern Blue).
   Loaded once by layout/milaros.liquid. Section-specific behaviour (product
   gallery, cart qty, countdown, tabs …) lives in each section's own inline
   <script>. This file only owns the SHARED chrome: icons, scroll progress,
   back-to-top, reveal-on-scroll, header search overlay, mobile menu, Esc.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* — Lucide icons: (re)draw whenever DOM changes — */
  function drawIcons() {
    if (window.lucide && typeof window.lucide.createIcons === 'function') {
      window.lucide.createIcons();
    } else {
      setTimeout(drawIcons, 120);
    }
  }
  window.milarosIcons = drawIcons;

  /* — Scroll progress bar + back-to-top — */
  function initScroll() {
    var bar = document.querySelector('[data-ml-progress]');
    var top = document.querySelector('[data-ml-totop]');
    if (!bar && !top) return;
    var ticking = false;
    function update() {
      var h = document.documentElement;
      var max = (h.scrollHeight - h.clientHeight) || 1;
      var p = Math.min(1, Math.max(0, h.scrollTop / max));
      if (bar) bar.style.width = (p * 100).toFixed(2) + '%';
      if (top) top.classList.toggle('is-on', h.scrollTop > 600);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    if (top) top.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
    update();
  }

  /* — Reveal on scroll (staggered) — */
  function initReveal() {
    var els = [].slice.call(document.querySelectorAll('.ml-reveal'));
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var vh = window.innerHeight || document.documentElement.clientHeight;
    // Above-the-fold reveals instantly (no fade) so page loads & navigation feel solid.
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < vh * 0.9) {
        el.classList.add('ml-instant');
        el.classList.add('is-in');
      }
    });
    // Below-the-fold: subtle reveal, triggered ~18% early so nothing flashes blank.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px 18% 0px', threshold: 0.01 });
    els.forEach(function (el) { if (el.className.indexOf('is-in') < 0) io.observe(el); });
    // Safety net: never leave content invisible if the observer misses something.
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 2000);
  }

  /* — Header search overlay + mobile menu — */
  function initHeader() {
    var body = document.body;
    /* Wird der Seitenscroll gesperrt, verschwindet auf dem Desktop die Scroll-
       leiste und alles darunter rutscht um deren Breite (gemessen 15 px) nach
       aussen. Denselben Platz als Innenabstand zurueckgeben — der Sprung
       entfaellt. Auf dem Handy liegt die Leiste ueber dem Inhalt, dort ist der
       Wert 0 und es passiert nichts. */
    function lockScroll(on) {
      if (on) {
        var pad = window.innerWidth - document.documentElement.clientWidth;
        if (pad > 0) body.style.paddingRight = pad + 'px';
        body.style.overflow = 'hidden';
      } else {
        body.style.overflow = '';
        body.style.paddingRight = '';
      }
    }
    window.milarosLockScroll = lockScroll;
    /* Der ausloesende Knopf sagt Screenreadern, ob sein Bereich offen ist. */
    function markTrigger(el, open) { if (el) el.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    /* Beim Schliessen geht der Fokus zurueck auf den Knopf im Kopfbereich. Ein
       normales focus() scrollt dieses Ziel in den sichtbaren Bereich — gemessen
       sprang die Seite dabei von Position 600 auf 673. `preventScroll` gibt den
       Fokus, ohne die Leseposition zu verlieren. */
    function focusOhneSprung(el) {
      if (!el || !el.focus) return;
      try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
    }
    window.milarosFocus = focusOhneSprung;
    function openEl(el) { if (!el) return; el.hidden = false; el.classList.add('is-open'); lockScroll(true); }
    function closeEl(el) { if (!el) return; el.classList.remove('is-open'); lockScroll(false); setTimeout(function () { el.hidden = true; }, 200); }

    var search = document.querySelector('[data-ml-search]');
    var menu = document.querySelector('[data-ml-menu]');

    // Focus trap: while an overlay is open, Tab must not walk the page behind it.
    var lastTrigger = null;
    function focusables(el) {
      return [].slice.call(el.querySelectorAll(
        'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])'
      )).filter(function (n) { return n.offsetParent !== null; });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var wish = document.querySelector('[data-ml-wishlist]');
      var open = [search, menu, wish].filter(function (el) { return el && !el.hidden; })[0];
      if (!open) return;
      var f = focusables(open);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (open.contains(document.activeElement) === false) { e.preventDefault(); first.focus(); }
    });

    document.addEventListener('click', function (e) {
      var openS = e.target.closest('[data-ml-search-open]');
      var openM = e.target.closest('[data-ml-menu-open]');
      var closeAttr = e.target.closest('[data-ml-close]');
      if (openS) { lastTrigger = openS; markTrigger(openS, true); e.preventDefault(); openEl(search); var inp = search && search.querySelector('input[type=search],input[name=q]'); if (inp) setTimeout(function () { inp.focus(); }, 60); }
      if (openM) { lastTrigger = openM; markTrigger(openM, true); e.preventDefault(); openEl(menu); var mf = menu && focusables(menu)[0]; if (mf) setTimeout(function () { mf.focus(); }, 60); }
      if (closeAttr) { e.preventDefault(); closeEl(search); closeEl(menu); if (lastTrigger) { markTrigger(lastTrigger, false); focusOhneSprung(lastTrigger); lastTrigger = null; } }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeEl(search); closeEl(menu); if (lastTrigger) { markTrigger(lastTrigger, false); focusOhneSprung(lastTrigger); lastTrigger = null; } }
    });
  }

  /* — Wishlist: ONE source of truth for every heart on every page —
     localStorage 'milaros:wishlist', keyed by product HANDLE. Any [data-ml-wish]
     button (grid card, collection, PDP, related, recently-viewed) shares this
     delegated toggle, so a favourite set anywhere shows everywhere and lands on
     the Merkliste page. Replaces the old per-section copies. */
  function initWishlist() {
    var KEY = 'milaros:wishlist';
    function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
    function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
    function paintAll() {
      var list = read();
      [].slice.call(document.querySelectorAll('[data-ml-wish]')).forEach(function (b) {
        var on = list.indexOf(b.getAttribute('data-ml-wish')) >= 0;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    window.milarosWishlistPaint = paintAll;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ml-wish]');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      var handle = btn.getAttribute('data-ml-wish');
      if (!handle) return;
      var list = read(), i = list.indexOf(handle);
      if (i >= 0) { list.splice(i, 1); } else { list.push(handle); }
      write(list);
      paintAll();
      document.dispatchEvent(new CustomEvent('milaros:wishlist-change', { detail: { handle: handle, active: i < 0 } }));
    });
    document.addEventListener('ml:rerender', paintAll);
    paintAll();
  }

  /* — Mobile-Drawer: Kategorie-Akkordeon —
     Genau eine Kategorie offen (openCat). Delegiert, damit der Drawer auch
     nach einem Re-Render funktioniert. Der Zustand lebt im DOM (.is-open),
     nicht in einer zweiten Variablen, die auseinanderlaufen koennte. */
  function initDrawerAccordion() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-ml-cat-toggle]');
      if (!btn) return;
      e.preventDefault();
      var cat = btn.closest('[data-ml-cat]');
      var sub = document.getElementById(btn.getAttribute('aria-controls'));
      var willOpen = !cat.classList.contains('is-open');
      // Nur eine Kategorie gleichzeitig — erst alles zu, dann die gewaehlte auf.
      [].forEach.call(document.querySelectorAll('[data-ml-cat]'), function (c) {
        c.classList.remove('is-open');
        var b = c.querySelector('[data-ml-cat-toggle]');
        var p = c.querySelector('.mlh-cat__sub');
        if (b) b.setAttribute('aria-expanded', 'false');
        if (p) p.hidden = true;
      });
      if (willOpen) {
        cat.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        if (sub) sub.hidden = false;
        if (!reduce) {
          // Nach dem Aufklappen soll die Kategorie sichtbar sein, nicht am Rand kleben.
          setTimeout(function () { cat.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 60);
        }
      }
      if (window.milarosIcons) window.milarosIcons();
    });
  }

  /* — Product carousels (v2) —
     ONE source for every rail on the site: home, PDP-related, collection.
     Contract: rail = [data-row="<key>"], buttons = [data-arrow="<key>|l|r"].
     Delegated, so rails that appear later (tab switch, async render) just work. */
  function initRails() {
    var STEP_MIN = 304, STEP_MAX = 360;

    function railFor(key) { return document.querySelector('[data-row="' + key + '"]'); }
    function step(rail) { return Math.max(STEP_MIN, Math.min(rail.clientWidth - 60, STEP_MAX)); }

    // A dead control must look dead: grey out an arrow at its end, and hide the
    // pair entirely when the rail fits and there is nothing to scroll at all.
    function paint(rail) {
      var key = rail.getAttribute('data-row');
      var max = rail.scrollWidth - rail.clientWidth - 2;
      var fits = max <= 0;
      [].forEach.call(document.querySelectorAll('[data-arrow^="' + key + '|"]'), function (b) {
        var left = b.getAttribute('data-arrow').slice(-1) === 'l';
        var dead = left ? rail.scrollLeft <= 2 : rail.scrollLeft >= max;
        b.hidden = fits;
        b.classList.toggle('is-off', !fits && dead);
        b.disabled = fits || dead;
      });
    }
    function paintAll() { [].forEach.call(document.querySelectorAll('[data-row]'), paint); }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-arrow]');
      if (!btn) return;
      var parts = btn.getAttribute('data-arrow').split('|');
      var rail = railFor(parts[0]);
      if (!rail) return;
      rail.scrollBy({ left: parts[1] === 'l' ? -step(rail) : step(rail), behavior: 'smooth' });
    });

    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (t && t.getAttribute && t.getAttribute('data-row')) paint(t);
    }, true);

    // Drag-to-scroll on pointer devices; touch already scrolls natively.
    [].forEach.call(document.querySelectorAll('[data-row]'), function (rail) {
      var down = false, startX = 0, startL = 0, moved = 0;
      rail.addEventListener('pointerdown', function (ev) {
        if (ev.pointerType === 'touch' || ev.button !== 0) return;
        down = true; moved = 0; startX = ev.clientX; startL = rail.scrollLeft;
        rail.style.scrollBehavior = 'auto';
      });
      rail.addEventListener('pointermove', function (ev) {
        if (!down) return;
        var dx = ev.clientX - startX;
        if (Math.abs(dx) > 3) { moved = Math.abs(dx); rail.scrollLeft = startL - dx; ev.preventDefault(); }
      });
      function end() { down = false; rail.style.scrollBehavior = ''; }
      rail.addEventListener('pointerup', function (ev) {
        // A real drag must not also fire the card link underneath.
        if (moved > 6) { ev.preventDefault(); var kill = function (c) { c.stopPropagation(); c.preventDefault(); };
          rail.addEventListener('click', kill, { capture: true, once: true });
          setTimeout(function () { rail.removeEventListener('click', kill, true); }, 0); }
        end();
      });
      rail.addEventListener('pointerleave', end);
      rail.addEventListener('pointercancel', end);
    });

    // Keyboard: a rail is focusable and responds to ←/→/Home/End.
    [].forEach.call(document.querySelectorAll('[data-row]'), function (rail) {
      if (!rail.hasAttribute('tabindex')) rail.setAttribute('tabindex', '0');
      if (!rail.hasAttribute('role')) rail.setAttribute('role', 'group');
      if (!rail.hasAttribute('aria-label')) rail.setAttribute('aria-label', 'Produktreihe — mit den Pfeiltasten blättern');
      rail.addEventListener('keydown', function (ev) {
        var k = ev.key;
        if (k !== 'ArrowLeft' && k !== 'ArrowRight' && k !== 'Home' && k !== 'End') return;
        ev.preventDefault();
        if (k === 'Home') rail.scrollTo({ left: 0, behavior: 'smooth' });
        else if (k === 'End') rail.scrollTo({ left: rail.scrollWidth, behavior: 'smooth' });
        else rail.scrollBy({ left: k === 'ArrowLeft' ? -step(rail) : step(rail), behavior: 'smooth' });
      });
    });

    paintAll();
    window.addEventListener('resize', paintAll);
    document.addEventListener('ml:rerender', paintAll);
    // Tab panels reveal a rail that was hidden (clientWidth 0) — repaint after.
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-mih-tab]')) setTimeout(paintAll, 30);
    });
  }

  /* — Richtlinienseiten (/policies/*): Inhaltsverzeichnis aus dem echten Text —
     Shopify liefert den Policy-Text als fertiges HTML aus dem Admin; wir koennen
     serverseitig weder IDs noch eine Gliederung vergeben. Darum hier: Ueberschriften
     nummerieren + verankern, daraus ein klebendes Verzeichnis bauen und beim Scrollen
     den aktiven Abschnitt markieren. Die Ebene wird erkannt (h2, sonst h3, sonst h4),
     weil die Texte im Admin unterschiedlich ausgezeichnet sind — der Widerruf nutzt
     h3, andere h2. Unter zwei Ueberschriften bleibt es einspaltig. */
  function initPolicyDoc() {
    // Gilt fuer BEIDE Dokumentarten: Shopifys /policies/* und unsere
    // Rechtstexte unter /pages/* (AGB, Impressum, Widerruf). Beide bekommen
    // dieselbe Meta-Zeile, dasselbe Verzeichnis und dieselbe Hilfekarte —
    // sonst fuehlen sich zwei Seiten mit demselben Zweck verschieden an.
    var box = document.querySelector('.shopify-policy__container');
    var body = box && box.querySelector('.shopify-policy__body');
    if (!box || !body) {
      box = document.querySelector('.mlp-wrap');
      body = box && box.querySelector('.mlp-doc');
    }
    if (!box || !body) return;
    // Kurzer Hinweis der alten r24-Seiten ist kein Dokument — keine Lesezeit, kein Verzeichnis.
    if (body.querySelector('.mlp-legacy')) return;

    var scope = body.querySelector('.rte') || body;
    var level = ['h2', 'h3', 'h4'].filter(function (l) { return scope.querySelector(l); })[0];
    var heads = level ? [].slice.call(scope.querySelectorAll(level)) : [];

    // "Letzte Aktualisierung: …" kommt aus Shopify als ganz normaler Absatz und
    // sieht deshalb aus wie Fliesstext. Als Meta-Zeile gehoert sie ueber das
    // Dokument, nicht mitten hinein.
    var firstP = scope.querySelector('p');
    var stand = '';
    if (firstP && /^\s*(Letzte Aktualisierung|Zuletzt aktualisiert)/i.test(firstP.textContent || '')) {
      stand = (firstP.textContent || '').replace(/^\s*(Letzte Aktualisierung|Zuletzt aktualisiert)\s*:?\s*/i, '').trim();
      firstP.remove();
    }
    // Lesezeit aus dem echten Textumfang — 200 Woerter/Minute.
    var woerter = ((scope.textContent || '').match(/\S+/g) || []).length;
    var minuten = Math.max(1, Math.round(woerter / 200));

    var meta = document.createElement('div');
    meta.className = 'mlpol-meta';
    meta.innerHTML =
      (stand ? '<span class="mlpol-meta__i"><i data-lucide="calendar-check" width="14" height="14" stroke-width="1.8"></i>Stand: <b>' + stand + '</b></span>' : '')
      + '<span class="mlpol-meta__i"><i data-lucide="clock" width="14" height="14" stroke-width="1.8"></i>ca. ' + minuten + ' Min. Lesezeit</span>'
      + (heads.length > 1 ? '<span class="mlpol-meta__i"><i data-lucide="list" width="14" height="14" stroke-width="1.8"></i>' + heads.length + ' Abschnitte</span>' : '');
    body.insertBefore(meta, body.firstChild);

    if (window.milarosIcons) window.milarosIcons();

    // Ohne mindestens zwei Ueberschriften lohnt kein Verzeichnis — die Seite
    // bleibt einspaltig, Meta-Zeile und Typografie gelten trotzdem.
    if (heads.length < 2) return;

    function slug(s, i) {
      var b = (s || '').toLowerCase()
        .replace(/[äöüß]/g, function (c) { return { 'ä': 'ae', 'ö': 'oe', 'ü': 'ue', 'ß': 'ss' }[c]; })
        .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 48);
      return 'abschnitt-' + (b || 'x') + '-' + (i + 1);
    }

    var items = heads.map(function (h, i) {
      var text = (h.textContent || '').trim();
      if (!h.id) h.id = slug(text, i);
      h.setAttribute('data-ml-num', i + 1);
      var a = document.createElement('a');
      a.className = 'mlpol-anchor';
      a.href = '#' + h.id;
      a.setAttribute('aria-label', 'Direktlink zu diesem Abschnitt');
      a.textContent = '#';
      h.appendChild(a);
      return { id: h.id, text: text, el: h, n: i + 1 };
    });


    var side = document.createElement('aside');
    side.className = 'mlpol-side';
    var card = document.createElement('nav');
    card.className = 'mlpol-card';
    card.setAttribute('aria-label', 'Inhalt dieser Richtlinie');
    var head = document.createElement('div');
    head.className = 'mlpol-card__h';
    head.textContent = 'Inhalt';
    var list = document.createElement('div');
    list.className = 'mlpol-toc';
    items.forEach(function (it) {
      var a = document.createElement('a');
      a.href = '#' + it.id;
      var n = document.createElement('span');
      n.className = 'n';
      n.textContent = it.n < 10 ? '0' + it.n : String(it.n);
      var t = document.createElement('span');
      t.textContent = it.text;              // textContent: kein Admin-HTML einschleusen
      a.appendChild(n); a.appendChild(t);
      list.appendChild(a);
    });
    card.appendChild(head); card.appendChild(list); side.appendChild(card);
    box.insertBefore(side, body);
    // Zweite Karte: Ausdrucken und Rueckfragen — auf einer Rechtsseite die zwei
    // Dinge, die Kundinnen dort tatsaechlich brauchen.
    var help = document.createElement('div');
    help.className = 'mlpol-card mlpol-help';
    help.innerHTML =
      '<div class="mlpol-card__h">Fragen dazu?</div>'
      + '<p class="mlpol-help__p">Wir beantworten Fragen zu diesem Dokument gern persönlich.</p>'
      + '<a class="mlpol-help__a" href="mailto:kontakt@milaros.de"><i data-lucide="mail" width="15" height="15" stroke-width="1.8"></i>kontakt@milaros.de</a>'
      + '<a class="mlpol-help__a" href="tel:+4917663137637"><i data-lucide="phone" width="15" height="15" stroke-width="1.8"></i>+49 176 63137637</a>'
      + '<button type="button" class="mlpol-help__b" data-ml-print><i data-lucide="printer" width="15" height="15" stroke-width="1.8"></i>Seite drucken</button>';
    side.appendChild(help);
    help.querySelector('[data-ml-print]').addEventListener('click', function () { window.print(); });

    box.classList.add('ml-has-toc');
    // Die Karten entstehen NACH dem ersten Lucide-Lauf — sonst bleiben die
    // <i data-lucide>-Platzhalter leer.
    if (window.milarosIcons) window.milarosIcons();

    var links = [].slice.call(list.querySelectorAll('a'));
    function setActive(id) {
      links.forEach(function (a) {
        var on = a.getAttribute('href') === '#' + id;
        a.classList.toggle('is-active', on);
        if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
    }
    function current() {
      var best = items[0].id;
      for (var i = 0; i < items.length; i++) {
        if (items[i].el.getBoundingClientRect().top <= 130) best = items[i].id; else break;
      }
      return best;
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { setActive(current()); ticking = false; });
    }, { passive: true });
    setActive(current());
  }

  /* — Rich-Text vereinheitlichen (theme-weit) —
     Händlertexte kommen in jedem Format: echte <ul><li>, "• …"-Zeilen als
     Fliesstext, doppelte Überschriften, leere Absätze. Hier wird NUR die
     DARSTELLUNG normalisiert — der gespeicherte Text bleibt unverändert —,
     damit Produkt, Kollektion, Seiten, Artikel und Policies identisch aussehen. */
  var RTE_SELECTOR = '.mip-rte, .mla-body, .mlpol-doc, .mlfaq-intro, .mlbr-intro, .ml-rte, [data-ml-rte]';
  var RTE_BULLET = /^\s*[•·▪●‣◦*]\s*|^\s*[-–—]\s+/;

  function normalizeRichText(rte) {
    if (!rte || rte.getAttribute('data-ml-normalized')) return;
    rte.setAttribute('data-ml-normalized', '1');

    // 1) Leere Absätze raus (erzeugen sonst Löcher im Rhythmus).
    [].slice.call(rte.querySelectorAll('p,div')).forEach(function (el) {
      if (!el.querySelector('img,ul,ol,table,iframe') && !el.textContent.trim()) el.remove();
    });

    // 2) Absätze ZEILENWEISE neu aufbauen: "• …" → <li>, andere Zeilen → eigener <p>.
    [].slice.call(rte.querySelectorAll('p,div')).forEach(function (p) {
      if (p.querySelector('ul,ol,li,img,table,iframe')) return;
      var html = p.innerHTML;
      if (!/<br/i.test(html) && !RTE_BULLET.test(p.textContent.trim())) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html.replace(/<br\s*\/?>/gi, '\n');
      var lines = tmp.textContent.split('\n').map(function (s) { return s.trim(); }).filter(Boolean);
      if (lines.length < 2) return;
      var frag = document.createDocumentFragment(), ul = null;
      lines.forEach(function (l) {
        if (RTE_BULLET.test(l)) {
          if (!ul) { ul = document.createElement('ul'); frag.appendChild(ul); }
          var li = document.createElement('li'); li.textContent = l.replace(RTE_BULLET, ''); ul.appendChild(li);
        } else {
          ul = null;
          var np = document.createElement('p'); np.textContent = l; frag.appendChild(np);
        }
      });
      p.parentNode.replaceChild(frag, p);
    });

    // 3) Wiederholte kurze Überschriften entfernen (auch nicht benachbart).
    var seen = {};
    [].slice.call(rte.children).forEach(function (el) {
      var t = el.textContent.trim().replace(/\s+/g, ' ');
      if (!t) return;
      var key = t.toLowerCase();
      if (t.length <= 44 && seen[key]) { el.remove(); return; }
      seen[key] = 1;
    });

    // 4) Zwischenüberschriften markieren: reine <strong>-Absätze, Label-Zeilen, erste Zeile.
    [].slice.call(rte.querySelectorAll('p')).forEach(function (p, idx) {
      var t = p.textContent.trim();
      if (!t) return;
      var onlyStrong = p.children.length === 1 && /^(STRONG|B)$/.test(p.children[0].tagName)
        && t === p.children[0].textContent.trim();
      // Die erste Zeile nur dann als Überschrift setzen, wenn sie auch kurz ist —
      // sonst würde auf Rechtsseiten ein langer Absatz zur Überschrift befördert.
      var firstAndShort = idx === 0 && t.length <= 80;
      if (onlyStrong || (t.length <= 44 && /:$/.test(t)) || firstAndShort) p.classList.add('is-head');
    });

    // 5) "Label: Wert" typografisch trennen → einheitliche Spezifikations-Zeilen.
    [].slice.call(rte.querySelectorAll('li')).forEach(function (li) {
      if (li.querySelector('ul,ol,img')) return;
      var t = li.textContent.trim(), i = t.indexOf(':');
      if (i > 0 && i <= 42 && t.length > i + 1) {
        var k = document.createElement('span'); k.className = 'k'; k.textContent = t.slice(0, i).trim();
        var v = document.createElement('span'); v.className = 'v'; v.textContent = t.slice(i + 1).trim();
        li.textContent = ''; li.appendChild(k); li.appendChild(v); li.classList.add('is-kv');
        if (li.parentNode && li.parentNode.tagName === 'UL') li.parentNode.classList.add('is-specs');
      }
    });
  }

  function initRichText() {
    [].slice.call(document.querySelectorAll(RTE_SELECTOR)).forEach(normalizeRichText);
  }
  window.milarosNormalizeRichText = initRichText;

  /* — Teilen: EINE Quelle für jeden Share-Button im Shop —
     Kontrakt: [data-ml-share="<url>"] (+ optional data-ml-share-title).
     Mobil öffnet die native Share-Sheet; sonst wird der Link in die Zwischen-
     ablage kopiert und kurz bestätigt. Delegiert, damit auch später gerenderte
     Karten (Merkliste, Karussells, Tab-Wechsel) ohne Zutun funktionieren. */
  function initShare() {
    var toastEl = null, toastTimer = null;

    function toast(msg) {
      if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'ml-toast';
        toastEl.setAttribute('role', 'status');
        toastEl.setAttribute('aria-live', 'polite');
        document.body.appendChild(toastEl);
      }
      toastEl.innerHTML = '<i data-lucide="check" width="15" height="15" stroke-width="2.4"></i>' + msg;
      drawIcons();
      // Kein requestAnimationFrame: der wird in inaktiven/gedrosselten Tabs nicht
      // ausgeliefert — der Hinweis bliebe unsichtbar. Ein erzwungener Reflow
      // startet die Transition zuverlässig und synchron.
      toastEl.classList.remove('is-on');
      void toastEl.offsetHeight;
      toastEl.classList.add('is-on');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2200);
    }

    function copyText(text, done) {
      function legacy() {
        try {
          var ta = document.createElement('textarea');
          ta.value = text; ta.setAttribute('readonly', '');
          ta.style.position = 'fixed'; ta.style.top = '-1000px';
          document.body.appendChild(ta); ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          done();
        } catch (err) { /* still no crash for the user */ }
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, legacy);
      } else { legacy(); }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ml-share]');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();     // nie die Karte mit-öffnen
      var url = btn.getAttribute('data-ml-share') || window.location.href;
      if (url.indexOf('http') !== 0) url = window.location.origin + url;
      var title = btn.getAttribute('data-ml-share-title') || document.title;
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
        return;
      }
      copyText(url, function () {
        btn.classList.add('is-done');
        setTimeout(function () { btn.classList.remove('is-done'); }, 1600);
        toast('Link kopiert');
      });
    });
  }

  function boot() {
    drawIcons();
    initRichText();
    initShare();
    initScroll();
    initReveal();
    initHeader();
    initWishlist();
    initDrawerAccordion();
    initRails();
    initPolicyDoc();
    // Redraw icons after late async content (predictive search, cart drawer …)
    document.addEventListener('ml:rerender', drawIcons);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
